'use strict';

import $ from 'jquery';

$('.access-tools .text-increase').click(function () {
	$("html").toggleClass("text-increased");
	if($("html").hasClass("text-increased")){
			$('.text-increase').attr('style', $(this).attr('style').replace('Text_Increase', 'Text_Decrease'));
			var text = $('.text-increase .sr-only').text().replace('increase', 'decrease');
			$('.text-increase .sr-only').text(text);

	} else {
			$('.text-increase').attr('style', $(this).attr('style').replace('Text_Decrease', 'Text_Increase'));
			var text = $('.text-increase .sr-only').text().replace('decrease', 'increase');
			$('.text-increase .sr-only').text(text);
	}
});

$('.access-tools .print').click(function() {
	window.print();
});
